import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const podcastEpisode = {
  fetchEpisode: lazyModuleMethod(() => import('./fetchEpisode'), 'default'),
  fetchEpisodes: lazyModuleMethod(() => import('./fetchEpisodes'), 'default'),
  createEpisode: lazyModuleMethod(() => import('./createEpisode'), 'default'),
  updateEpisode: lazyModuleMethod(() => import('./updateEpisode'), 'default'),
  uploadAudio: lazyModuleMethod(() => import('./uploadAudio'), 'default'),
}
